import {ExternalLinksHandlersFactory} from "../../external-links-handlers-factory";
import {
    IRegistrationExternalLinkHandler
} from "../../../handlers/registration/registration.external-link-handler.interface";
import {
    MichiganRegistrationExternalLinkHandler
} from "../../../handlers/registration/regulations/michigan/michigan.registration.external-link-handler";

export class MichiganExternalLinksHandlersFactory extends ExternalLinksHandlersFactory {
    get registration(): IRegistrationExternalLinkHandler {
        return new MichiganRegistrationExternalLinkHandler(this.services);
    }
}